import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { mealsAPI } from "../../services/api";
import MealForm from "./MealForm";
import toast from "react-hot-toast";

const CreateMeal = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createMealMutation = useMutation(mealsAPI.createMeal, {
      onSuccess: (data) => {
        toast.success("Meal created successfully!");
        queryClient.invalidateQueries("vendor-meals");
        queryClient.invalidateQueries("meals");
        navigate("/vendor/meals");
      },
    onError: (error) => {
      console.error("Error creating meal:", error);
      console.error("Error response:", error.response?.data);
      const errorMessage = error.response?.data?.message || "Failed to create meal";
      const validationErrors = error.response?.data?.errors;
      if (validationErrors && validationErrors.length > 0) {
        const errorDetails = validationErrors.map((err) => `${err.param}: ${err.msg}`).join(", ");
        toast.error(`${errorMessage}: ${errorDetails}`);
      } else {
        toast.error(errorMessage);
      }
    },
  });

  const handleSave = async (formData) => {
    try {
      await createMealMutation.mutateAsync(formData);
    } catch (error) {
      // Error is handled by the mutation's onError callback
      throw error;
    }
  };

  const handleCancel = () => {
    navigate("/vendor/meals");
  };

  return <MealForm onSave={handleSave} onCancel={handleCancel} />;
};

export default CreateMeal;

